import styled from 'styled-components';

export const ScreenFormContanier = styled.section`
  display: flex;
  flex-direction: column;
`;
